import clsx from "clsx";
import React, { useEffect } from "react";
import {Form,InputGroup} from "react-bootstrap";
import Image from "react-bootstrap/Image";
import { useForm } from "react-hook-form";
import _ from "lodash";
import * as axiosInstance from "../../services/axiosInstance";
import LoadingOverlay from "../../components/LoadingOverlay";
import * as StorageManager from "../../utils/StorageManager";
import constants from "../../constants";
import * as authSelectors from "../../selectors/auth";
import PAGE from "../../utils/Destination";
import { useDispatch } from "react-redux";
import * as userActions from "../../action/user";
import { faEye,faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as CryptoHelper from "../../utils/CryptoHelper";

function Login({history}) {
  const [initialValues, setInitialValues] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [passwordView, setPasswordView] = React.useState(false);
  const dispatch = useDispatch();


  const onSubmit = async (values) => {
    const { rememberMe, trading_id } = values;
    setLoading(true);
    try {
      const encrytionResult = await axiosInstance.post(
        "/clientarea/encryption/create",
        {},
        false,
        false,
        "",
        {},
        true,
      );
      const result = _.get(encrytionResult,['data'],null)
      const encryptedKey = CryptoHelper.decryptData(result.key, result.salt, result.iv, process.env.REACT_APP_PASSPHRASE);
      const encryptedPassword = CryptoHelper.encryptData(values.password, result.salt, result.iv, encryptedKey);
      const newSubmitValues = {...values, trading_id: trading_id.toUpperCase(),password: encryptedPassword,encryption_id:result.id};
      const response = await axiosInstance.post("clientarea/auth/login", newSubmitValues,true,false,"Login Successfully");
      if (response) {
        const token = authSelectors.getAuthToken(response);
        const user = authSelectors.getAuthUser(response);
        await StorageManager.setToken(constants.AUTH_TOKEN, token);
        dispatch(userActions.updateUserDetail(user));
        navigateToHome();
      }

    } catch (e) {
      console.log("ee" + e);
    } finally {
      setLoading(false);
    }
  };

  const navigateToHome = () => {
    history.push(PAGE.DASHBOARD);

  };

  const onError = (error) => {
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onSubmit",
    // reValidateMode: "onChange",
    defaultValues: initialValues,
    values:initialValues
  });

  const onclickForgotPassword = (e) => {
    e.preventDefault();
    history.push(PAGE.FORGET_PASSWORD);
  };

  const onclickActivation = (e) => {
    e.preventDefault();
    history.push(PAGE.USER_ACTIVATION);
  };

  return (
      <div className="col-xxl-4 col-lg-4 col-lg-5 col-md-7">
        <div className="card position-relative">
          <div className="card-header pt-4 pb-4 text-center position-relative">
            <Image src="/img/ta-securities-logo.png" style={{height: "55px", width: "100%", objectFit: "contain"}}/>
          </div>
          <div className="card-body">
            <div className="text-center w-75 m-auto">
              <h4 className="text-dark-50 text-center mt-0 font-weight-bold title">Sign In</h4>
            </div>

            <Form onSubmit={handleSubmit(onSubmit, onError)} className="mt-3">
              <Form.Group className="mb-3">
                <div className="d-flex justify-content-between">
                  <Form.Label className="formLabel required">Username</Form.Label>
                  <a
                      href={PAGE.FAQ}
                      className="gridLink"
                      style={{fontSize: "0.65rem", textAlign: "center", justifyContent: "center"}}
                      target="_blank"
                  >
                    <span>FAQ</span>
                  </a>
                </div>
                <Form.Control
                    isInvalid={!_.isEmpty(errors && errors.trading_id)}
                    name="trading_id"
                    className="formControl auto-uppercase"
                    type="text"
                    placeholder="Enter your client code"
                      {...register("trading_id", {required: "Please enter your client code"})}
                  />
                  {errors.trading_id && (
                      <Form.Control.Feedback type="invalid">{errors.trading_id.message}</Form.Control.Feedback>
                  )}
              </Form.Group>
              <Form.Group className="mb-3">
              <div className="d-flex justify-content-between">
                  <Form.Label className="formLabel required">Password</Form.Label>
                  <a
                      href={PAGE.FORGET_PASSWORD}
                      className="gridLink"
                      style={{fontSize: ".65rem"}}
                      onClick={onclickForgotPassword}
                  >
                    <span>Forgot your password?</span>
                  </a>
                </div>
                <InputGroup className="mb-3">

                  <Form.Control
                      className="formControl"
                      isInvalid={!_.isEmpty(errors && errors.password)}
                      type={passwordView ? "input" : "password"}
                      placeholder="Enter your password"
                      name="password"
                      {...register("password", {required: "Please enter your password"})}
                  >
                  </Form.Control>
                  <InputGroup.Text id="basic-addon1">
                    <FontAwesomeIcon onClick={() => setPasswordView(prevState => !prevState)} className="password-icon"
                                     icon={passwordView ? faEyeSlash : faEye} color="#666666"/>
                  </InputGroup.Text>
                  {errors.password && (
                      <Form.Control.Feedback type="invalid">{errors.password.message}</Form.Control.Feedback>
                  )}
                </InputGroup>
              </Form.Group>
              <div className="text-center">
                <button className={clsx("btn btn-primary btn-fill mt-2 mb-2")} type="submit">
                  Log In
                </button>
                <a
                    href={PAGE.USER_ACTIVATION}
                    className="gridLink mb-4"
                    style={{fontSize: "0.8rem", textAlign: "center", justifyContent: "center"}}
                    onClick={onclickActivation}
                >
                  <span>First Time Login Activation</span>
                </a>
              </div>
            </Form>
          </div>
          <LoadingOverlay loading={loading}></LoadingOverlay>
        </div>
      </div>
  );
}

export default Login;
